export default{
    methods:{
        textOverride(intext){
            if(intext.includes('Mobile IDs')){
                if(window.TEXT_OVERRIDE_MOBILEID==undefined){return intext}
                  
                let replaceText = window.TEXT_OVERRIDE_MOBILEID
                console.log(replaceText)
                //specific case
                if(replaceText=='Driver'){
                    intext='Driver Files'
                }else{
                    intext = intext.replaceAll('Mobile ID',replaceText)
                }

                
            }else if(intext.includes('Student')){
                if(window.TEXT_OVERRIDE_STUDENT==undefined){return intext}
                    
                let replaceText = window.TEXT_OVERRIDE_STUDENT
                intext = intext.replaceAll('Student',replaceText)
                
            }else if(intext.includes('student')){
                if(window.TEXT_OVERRIDE_STUDENT==undefined){return intext}
                    
                let replaceText = window.TEXT_OVERRIDE_STUDENT.toLowerCase()
                intext = intext.replaceAll('student',replaceText)
            }
            return intext
        },
    }
}